import { cn as e } from "../cn.js";
import { cva as t } from "class-variance-authority";
// src/design/button/style.ts
var n = (t, n) => {
	let r = n;
	if (t === "solid") {
		let t = {
			primary: {
				bg: "bg-primary",
				fg: "text-primary-foreground",
				hover: "hover:bg-primary-hover",
				active: "active:bg-primary-active"
			},
			default: {
				bg: "bg-neutral-solid",
				fg: "text-neutral-solid-foreground",
				hover: "hover:bg-neutral-solid-hover",
				active: "active:bg-neutral-solid-active"
			},
			danger: {
				bg: "bg-destructive",
				fg: "text-destructive-foreground",
				hover: "hover:bg-destructive-hover",
				active: "active:bg-destructive-active"
			},
			success: {
				bg: "bg-success",
				fg: "text-success-foreground",
				hover: "hover:bg-success-hover",
				active: "active:bg-success-active"
			},
			warning: {
				bg: "bg-warning",
				fg: "text-warning-foreground",
				hover: "hover:bg-warning-hover",
				active: "active:bg-warning-active"
			},
			info: {
				bg: "bg-info",
				fg: "text-info-foreground",
				hover: "hover:bg-info-hover",
				active: "active:bg-info-active"
			},
			discovery: {
				bg: "bg-discovery",
				fg: "text-discovery-foreground",
				hover: "hover:bg-discovery-hover",
				active: "active:bg-discovery-active"
			}
		}[r];
		return e(t.bg, t.fg, t.hover, t.active, "focus-ring", "disabled:bg-accent disabled:text-muted-foreground disabled:cursor-not-allowed disabled:shadow-none disabled:hover:bg-accent");
	}
	if (t === "subtle") {
		let t = {
			primary: {
				bg: "bg-secondary",
				text: "text-primary",
				hoverBg: "hover:bg-secondary-hover",
				activeBg: "active:bg-secondary-active"
			},
			default: {
				bg: "bg-muted",
				text: "text-foreground",
				hoverBg: "hover:bg-muted-hover",
				activeBg: "active:bg-muted-active"
			},
			danger: {
				bg: "bg-destructive/10",
				text: "text-destructive-text",
				hoverBg: "hover:bg-destructive/20",
				activeBg: "active:bg-destructive/30"
			},
			success: {
				bg: "bg-success/10",
				text: "text-success-text",
				hoverBg: "hover:bg-success/20",
				activeBg: "active:bg-success/30"
			},
			warning: {
				bg: "bg-warning/10",
				text: "text-warning-text",
				hoverBg: "hover:bg-warning/20",
				activeBg: "active:bg-warning/30"
			},
			info: {
				bg: "bg-info/10",
				text: "text-info-text",
				hoverBg: "hover:bg-info/20",
				activeBg: "active:bg-info/30"
			},
			discovery: {
				bg: "bg-discovery/10",
				text: "text-discovery-text",
				hoverBg: "hover:bg-discovery/20",
				activeBg: "active:bg-discovery/30"
			}
		}[r];
		return e(t.bg, t.text, t.hoverBg, t.activeBg, "focus-ring", "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed disabled:hover:bg-muted");
	}
	if (t === "secondary") {
		let t = {
			primary: {
				bg: "bg-secondary",
				text: "text-primary",
				hoverBg: "hover:bg-secondary/90",
				activeBg: "active:bg-secondary/80"
			},
			default: {
				border: "border border-border",
				bg: "bg-card",
				text: "text-foreground",
				hoverBg: "hover:bg-muted",
				activeBg: "active:bg-muted-hover"
			},
			danger: {
				bg: "bg-destructive/10",
				text: "text-destructive-text",
				hoverBg: "hover:bg-destructive/20",
				activeBg: "active:bg-destructive/30"
			},
			success: {
				bg: "bg-success/10",
				text: "text-success-text",
				hoverBg: "hover:bg-success/20",
				activeBg: "active:bg-success/30"
			},
			warning: {
				bg: "bg-warning/10",
				text: "text-warning-text",
				hoverBg: "hover:bg-warning/20",
				activeBg: "active:bg-warning/30"
			},
			info: {
				bg: "bg-info/10",
				text: "text-info-text",
				hoverBg: "hover:bg-info/20",
				activeBg: "active:bg-info/30"
			},
			discovery: {
				bg: "bg-discovery/10",
				text: "text-discovery-text",
				hoverBg: "hover:bg-discovery/20",
				activeBg: "active:bg-discovery/30"
			}
		}[r];
		return e(t?.border || "", t.bg, t.text, t.hoverBg, t.activeBg, "focus-ring", "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed disabled:hover:bg-muted");
	}
	if (t === "outline") {
		let t = {
			primary: {
				border: "border-primary",
				text: "text-primary",
				hoverBg: "hover:bg-secondary",
				activeBg: "active:bg-secondary-hover"
			},
			default: {
				border: "border-input-border",
				text: "text-foreground",
				hoverBg: "hover:bg-muted",
				activeBg: "active:bg-muted-hover"
			},
			danger: {
				border: "border-destructive",
				text: "text-destructive-text",
				hoverBg: "hover:bg-destructive/10",
				activeBg: "active:bg-destructive/20"
			},
			success: {
				border: "border-success",
				text: "text-success-text",
				hoverBg: "hover:bg-success/10",
				activeBg: "active:bg-success/20"
			},
			warning: {
				border: "border-warning",
				text: "text-warning-text",
				hoverBg: "hover:bg-warning/10",
				activeBg: "active:bg-warning/20"
			},
			info: {
				border: "border-info",
				text: "text-info-text",
				hoverBg: "hover:bg-info/10",
				activeBg: "active:bg-info/20"
			},
			discovery: {
				border: "border-discovery",
				text: "text-discovery-text",
				hoverBg: "hover:bg-discovery/10",
				activeBg: "active:bg-discovery/20"
			}
		}[r];
		return e("border bg-transparent", t.border, t.text, t.hoverBg, t.activeBg, "focus-ring", "disabled:border-border disabled:text-muted-foreground disabled:cursor-not-allowed disabled:bg-transparent disabled:hover:bg-transparent disabled:hover:border-border");
	}
	if (t === "ghost") {
		let t = {
			primary: {
				text: "text-primary",
				hoverBg: "hover:bg-secondary",
				activeBg: "active:bg-secondary-hover"
			},
			default: {
				text: "text-foreground",
				hoverBg: "hover:bg-muted",
				activeBg: "active:bg-muted-hover"
			},
			danger: {
				text: "text-destructive-text",
				hoverBg: "hover:bg-destructive/10",
				activeBg: "active:bg-destructive/20"
			},
			success: {
				text: "text-success-text",
				hoverBg: "hover:bg-success/10",
				activeBg: "active:bg-success/20"
			},
			warning: {
				text: "text-warning-text",
				hoverBg: "hover:bg-warning/10",
				activeBg: "active:bg-warning/20"
			},
			info: {
				text: "text-info-text",
				hoverBg: "hover:bg-info/10",
				activeBg: "active:bg-info/20"
			},
			discovery: {
				text: "text-discovery-text",
				hoverBg: "hover:bg-discovery/10",
				activeBg: "active:bg-discovery/20"
			}
		}[r];
		return e("bg-transparent", t.text, t.hoverBg, t.activeBg, "focus-ring", "disabled:text-muted-foreground disabled:cursor-not-allowed disabled:bg-transparent disabled:hover:bg-transparent disabled:hover:text-muted-foreground");
	}
	if (t === "link") {
		let t = {
			primary: {
				text: "text-primary",
				hover: "hover:text-primary"
			},
			default: {
				text: "text-foreground",
				hover: "hover:text-muted-foreground"
			},
			danger: {
				text: "text-destructive-text",
				hover: "hover:text-destructive-text"
			},
			success: {
				text: "text-success-text",
				hover: "hover:text-success-text"
			},
			warning: {
				text: "text-warning-text",
				hover: "hover:text-warning-text"
			},
			info: {
				text: "text-info-text",
				hover: "hover:text-info-text"
			},
			discovery: {
				text: "text-discovery-text",
				hover: "hover:text-discovery-text"
			}
		}[r];
		return e("bg-transparent underline-offset-4 hover:underline", t.text, t.hover, "focus-visible:rounded-sm focus-ring", "disabled:text-muted-foreground disabled:cursor-not-allowed disabled:no-underline disabled:hover:text-muted-foreground disabled:hover:no-underline");
	}
	return "";
}, r = {
	xs: "xs",
	sm: "sm",
	md: "sm",
	lg: "md",
	xl: "lg"
}, i = {
	xs: "p-1 min-h-6 min-w-6",
	sm: "p-1.5 min-h-8 min-w-8",
	md: "p-2 min-h-10 min-w-10",
	lg: "p-3 min-h-12 min-w-12",
	xl: "p-4 min-h-14 min-w-14"
}, a = t("inline-flex items-center cursor-pointer justify-center font-medium whitespace-nowrap rounded-md transition-all duration-normal ease-standard", {
	variants: {
		size: {
			xs: "text-xs px-2 py-1 gap-1.5 min-h-6",
			sm: "text-label px-3 py-1.5 gap-2 h-8 min-h-8",
			md: "text-base px-4 py-2 gap-2 min-h-10",
			lg: "text-md px-6 py-3 gap-2.5 min-h-12",
			xl: "text-lg px-8 py-4 gap-3 min-h-14"
		},
		fullWidth: {
			true: "w-full",
			false: ""
		},
		loading: {
			true: "cursor-wait relative",
			false: ""
		}
	},
	defaultVariants: {
		size: "sm",
		fullWidth: !1,
		loading: !1
	}
});
export { a as buttonBase, n as getVariantStyles, i as iconOnlySizeStyles, r as iconSizeMap };

//# sourceMappingURL=style.js.map